import React from "react";

const AvatarEmpleado = ({ empleado, size = 40 }) => {
  const getInitials = (nombre, apellido) => {
    const firstInitial = nombre ? nombre.charAt(0).toUpperCase() : '';
    const lastInitial = apellido ? apellido.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  };

    return <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
        {/* <span className="badge badge-success badge-light" style={{ width: size, height: size, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {getInitials(empleado?.nombre, empleado?.apellido)}
        </span> */}

        {`${empleado.nombre} ${empleado.apellido}`}
    </div>;
}

export default AvatarEmpleado;

